/* eslint-disable react/prop-types */
import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { makeStyles } from '@material-ui/core/styles';
import { useTranslation } from 'react-i18next';
import {
  Grid,
  List,
  Divider,
  ListItem,
  IconButton,
  ListItemIcon,
  ListItemText,
  Typography,
  Collapse,
} from '@material-ui/core';
import {
  ChevronLeft,
  Dashboard,
  Help,
  Group,
  CalendarToday,
  AssignmentInd,
  ListAlt,
  Edit,
  MenuBook,
  Notifications,
  ExpandLess,
  ExpandMore,
  Folder,
  FolderShared,
} from '@material-ui/icons';
import MenuItem from './MenuItem';

const useStyles = makeStyles((theme) => ({
  drawerContainer: {
    overflow: 'auto',
  },
  drawerHeader: {
    display: 'flex',
    flexGrow: 1,
    alignItems: 'center',
    paddingLeft: '1em',
    ...theme.mixins.toolbar,
  },
  menuTitle: {
    fontFamily: 'Roboto',
    color: '#0000008a',
  },
  menuSubtitle: {
    fontSize: '0.75rem',
    fontFamily: 'Roboto',
    lineHeight: 1.6,
    color: '#0000008a',
  },
  menuCategories: {
    fontSize: '1.25rem',
    fontFamily: 'Roboto',
    lineHeight: 1.6,
    color: '#0000008a',
  },
}));

const MenuTeacher = ({
  handleDrawerClose, user,
}) => {
  const classes = useStyles();
  const { t } = useTranslation();
  const [archivesOpen, setArchivesOpen] = useState(false);

  return (
    <div className={classes.drawerContainer}>
      <div className={classes.drawerHeader}>
        <IconButton
          onClick={handleDrawerClose}
          aria-label="Dérouler"
        >
          <ChevronLeft />
        </IconButton>
        <Grid container>
          <Grid item md={12}>
            <Typography component="p" variant="body1" className={classes.menuTitle}>
              {`${user.firstname} ${user.name}`}
            </Typography>
          </Grid>
        </Grid>
      </div>
      <Divider />
      <List>
        <ListItem component={Link} to="/home" button>
          <ListItemIcon><Dashboard /></ListItemIcon>
          <ListItemText primary={t('menuTeacher.dashboard', 'Tableau de bord')} />
        </ListItem>

        <ListItem component={Link} to="/teacher/groups" button>
          <ListItemIcon><Group /></ListItemIcon>
          <ListItemText primary={t('menuTeacher.groups', 'Groupes')} />
        </ListItem>

        <ListItem component={Link} to="/teacher/calendar" button>
          <ListItemIcon><CalendarToday /></ListItemIcon>
          <ListItemText primary={t('menuTeacher.agenda', 'Agenda')} />
        </ListItem>

        <ListItem component={Link} to="/teacher/signatures" button>
          <ListItemIcon><AssignmentInd /></ListItemIcon>
          <ListItemText primary={t('menuTeacher.presenceSheets', 'Feuilles de présence')} />
        </ListItem>

        <ListItem component={Link} to="/documents" button>
          <ListItemIcon><FolderShared /></ListItemIcon>
          <ListItemText primary={t('menuTeacher.documents', 'Documents')} />
        </ListItem>

        <ListItem component={Link} to="/teacher/reports" button>
          <ListItemIcon><ListAlt /></ListItemIcon>
          <ListItemText primary={t('menuTeacher.reports', 'Rapports')} />
        </ListItem>

        <ListItem component={Link} to="/teacher/exams" button>
          <ListItemIcon><Edit /></ListItemIcon>
          <ListItemText primary={t('menuTeacher.corrections', 'Corrections')} />
        </ListItem>

        {user.isEW === false && (
          <ListItem component={Link} to="/teacher/resources" button>
            <ListItemIcon><MenuBook /></ListItemIcon>
            <ListItemText primary={t('menuTeacher.elearningMW', 'E-learning Medical World')} />
          </ListItem>
        )}

        <ListItem onClick={() => setArchivesOpen(!archivesOpen)} button>
          <ListItemIcon><Folder /></ListItemIcon>
          <ListItemText primary={t('menuTeacher.archives.title', 'Archives')} />
          {archivesOpen ? <ExpandLess /> : <ExpandMore />}
        </ListItem>

        <Collapse in={archivesOpen} timeout="auto" unmountOnExit>
          <Divider />
          <List component="div" style={{ marginLeft: '5%', width: '95%' }}>
            <MenuItem
              name={t('menuTeacher.archives.notifications', 'Notifications')}
              selectedRoute=""
              handleDrawerClose={() => { }}
              route="/teacher/archives/notifications"
              icon={<Notifications />}
            />
            <MenuItem
              name={t('menuTeacher.archives.reports', 'Rapports')}
              selectedRoute=""
              handleDrawerClose={() => { }}
              route="/teacher/archives/reports"
              icon={<ListAlt />}
            />
          </List>
          <Divider />
        </Collapse>

        <ListItem component={Link} to="/teacher/contact" button>
          <ListItemIcon><Help /></ListItemIcon>
          <ListItemText primary={t('menuTeacher.help', 'Assistance')} />
        </ListItem>
      </List>
    </div>
  );
};

MenuTeacher.propTypes = {
  handleDrawerClose: PropTypes.func.isRequired,
};

export default MenuTeacher;
